const inicialState = {
  dataInicio: '',
  dataFim: '',
  filtroValue: '',
  lista: [],
  tipo: '',
  imprimir: false,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/relatorios/store/relatorios.state.js